export enum HorizonContext {
	Ocean_Sea = 'Ocean/Sea',
	Lake_River = 'Lake/River',
	Mountain_Hills = 'Mountain/Hills',
	Desert_Mountains_Mesas = 'Desert Mountains / Mesas',
	Forest_Woodland = 'Forest/Woodland',
	Mixed_Natural_Landscape = 'Mixed Natural Landscape',
	Arid_Canyon_Wash = 'Arid Canyon / Wash',
	Open_Landscape_Fields = 'Open Landscape/Fields',
	Vegetated_Desert = 'Vegetated Desert',
	Urban_Skyline = 'Urban Skyline',
	Mixed_Urban = 'Mixed Urban',
	Desert_Urban_Edge = 'Desert Urban Edge',
	Barren_Disturbed_Landscape = 'Barren / Disturbed Landscape',
	No_Dominant_Horizon = 'No dominant horizon feature',
}

/**
 * BioScore impact values for different horizon contexts
 * Based on the "Beyond Horizon Assumptions" table
 */
export const HORIZON_CONTEXT_SCORES: Record<HorizonContext, number> = {
	[HorizonContext.Ocean_Sea]: 7,
	[HorizonContext.Lake_River]: 6,
	[HorizonContext.Mountain_Hills]: 6,
	[HorizonContext.Desert_Mountains_Mesas]: 6,
	[HorizonContext.Forest_Woodland]: 6,
	[HorizonContext.Mixed_Natural_Landscape]: 6,
	[HorizonContext.Arid_Canyon_Wash]: 6,
	[HorizonContext.Open_Landscape_Fields]: 5,
	[HorizonContext.Vegetated_Desert]: 5,
	[HorizonContext.Urban_Skyline]: 5,
	[HorizonContext.Mixed_Urban]: 4,
	[HorizonContext.Desert_Urban_Edge]: 4,
	[HorizonContext.Barren_Disturbed_Landscape]: 4,
	[HorizonContext.No_Dominant_Horizon]: 4,
};
